module.exports = __webpack_public_path__ + "static/media/tire-image.6551f47f.svg";